'use strict';
require('../../../modules/es.array.flat-map');
require('../../../modules/es.array.unscopables.flat-map');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').flatMap;
